import {
  PatientDocumentControllerApi,
  UpdatePatientDocumentDocumentFormatEnum,
  UpdatePatientDocumentDocumentTagEnum,
} from "../../services";
import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

type Params = {
  patientDocumentId: string;
  name: string;
  documentTag: UpdatePatientDocumentDocumentTagEnum;
  documentDate?: string;
  documentDescription?: string;
  documentFormat?: UpdatePatientDocumentDocumentFormatEnum;
  file: File;
  xTENANTID?: string;
};

/**
 * @author Rajkumar Rathod
 */
export const usePatientDocumentUpdate = () =>
  useMutationWithLoading(async (params: Params) =>
    new PatientDocumentControllerApi(getConfigObject()).updatePatientDocument(
      params.patientDocumentId,
      params.name,
      params.documentTag,
      params.documentDate,
      params.documentDescription,
      params.documentFormat,
      params.xTENANTID,
      params.file
    )
  );
